/**
 * @fileoverview Custom callback functions for handling events from the Filestack picker.
 *
 * This file is required by FileStackPicker.js. Since the external Filestack client
 * cannot directly access our internal DOM elements, InitFileStackUploader.js passes
 * the necessary form context through FileStackPicker.js to these functions.
 */


var customerFileInputCount = 0;// Global counter for naming the hidden file inputs sequentially.

/**
 * Filestack callback executed when all files in a single picker session have finished uploading.
 * It iterates over successful/failed files, updates the form, and submits.
 *
 * @param {Object} response The response object provided by the Filestack client.
 * @param {Object} context The application context passed from InitFileStackUploader.js.
 * @param {jQuery} context.uploadForm The jQuery object for the main submission form.
 * @param {jQuery} context.uploadButton The jQuery object for the button that opened the picker.
 * @exports {Function} uploadComplete
 */
export function uploadComplete(response, context){
    const { uploadForm, uploadButton } = context;

    for(let index in response.filesUploaded){
        successfulFileUpload(response.filesUploaded[index], uploadForm);
    }

    for(let index in response.filesFailed){
        failedFileUpload(response.filesUploaded[index]);
    }

    if(response.filesUploaded.length > 0) {
        uploadButton.find('span').text('Sending...').prop('disabled', true);
        // uploadForm.submit();

        // Fire a custom event on the form element.
        uploadForm.trigger('filestack:upload-success', [response.filesUploaded]);
    }

    if (response.filesFailed.length > 0) {
        // Fire a custom event on the form element.
        uploadForm.trigger('filestack:upload-failure', [response.filesFailed]);
    }
}

/**
 * Handles a single successfully uploaded file.
 * This function appends hidden input fields to the form to pass the Filestack file details
 * (filename, URL, size, handle) to the server upon form submission.
 *
 * @param {Object} file The Filestack file object for a successful upload.
 * @param {jQuery} uploadForm The jQuery object for the form to append inputs to.
 */
function successfulFileUpload(file, uploadForm){
    var baseName    = 'files[' + customerFileInputCount + ']';

    customerFileInputCount++;

    uploadForm.append(
        $('<input>').attr({
            type: 'hidden',
            name: baseName + '[filename]',
            class: 'uploaded-file-input',
            value: file.filename
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            name: baseName + '[url]',
            class: 'uploaded-file-input',
            value: file.url
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            name: baseName + '[size]',
            class: 'uploaded-file-input',
            value: file.size
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            name: baseName + '[handle]',
            class: 'uploaded-file-input',
            value: file.handle
        })
    );
    const $inputField = $('[data-field="imageName"]');

    if ($inputField.length > 0) {
        let name = file.filename;

        // Remove file extension (e.g., "image.png" -> "image")
        name = name.replace(/\.[^/.]+$/, "");

        if ($inputField.val().trim() === "") {
            $inputField.val(name);
        }
    }
}

/**
 * Placeholder function for handling files that failed to upload.
 * Currently only logs file details (variables reserved for future error reporting).
 * @param {Object} file The Filestack file object for a failed upload.
 */
function failedFileUpload(file){
    var filename    = file.filename;
    var url         = file.url;
}

/**
 * Filestack callback executed immediately when a user selects a file (before upload starts).
 * Used here for client-side file type validation.
 *
 * @param {Object} file The Filestack file object for the selected file.
 * @param {Object} context The application context (used here to maintain the function signature consistency).
 * @exports {Function} fileSelected
 */
export function fileSelected(file, context){
    var extension   = file.filename.split('.').pop();
    var exclude     = ['exe', 'dmg'];

    if(exclude.includes(extension))
        throw new Error('Invalid File Type');
}